'use strict';

const adformConstants = require('../adformConstants');
const ADFORM_PLACEHOLDER_CLASS = 'adform-placeholder';
const SLIDE_CLASS = 'swiper-slide';

/**
 * Adds adform placeholder.
 * note: not bootstrap placeholder.
 * @param {Element|null} element - element that needs to be covered with placeholder
 */
function addAdformPlaceholder(element) {
    element?.classList.add(ADFORM_PLACEHOLDER_CLASS);
}

/**
 * Removes adform placeholder.
 * note: not bootstrap placeholder.
 * @param {Element|null} element - element that has placeholder logic
 */
function removeAdformPlaceholder(element) {
    element?.classList.remove(ADFORM_PLACEHOLDER_CLASS);
}

/**
 * Adjusts data-tracking-position property on slides.
 * Hint: useful after new slides are added.
 * @param {Element} slider - slider element
 */
function adjustSlideTrackingIndexes(slider) {
    slider.querySelectorAll(`.${SLIDE_CLASS}`).forEach((slide, index) => {
        slide.setAttribute('data-tracking-position', index + 1);
    });
}

/**
 * Runs the two given init functions in the order adform's request/response lifecycle requires:
 * response-handling listeners must be registered before request triggers are fired,
 * otherwise a request could dispatch its response event (e.g. an early "no-bids" event on an invalid request)
 * before anything is listening for it.
 * @param {Function} initResponseHandlingEvents - registers listeners for the bids-ready/no-bids events
 * @param {Function} initMakeRequestEvents - fires/wires the adform request trigger(s)
 */
function initAdformRequestLifecycle(initResponseHandlingEvents, initMakeRequestEvents) {
    initResponseHandlingEvents();
    initMakeRequestEvents();
}

module.exports = {
    getBuyerUid: function () {
        // eslint-disable-next-line no-underscore-dangle
        return window.Adform?._uid || adformConstants.BUYER_UID_FALLBACK;
    },
    getLoggedInUserId: function () {
        const key = 'loggedInUserId';
        if (!(key in window)) {
            // eslint-disable-next-line no-console
            console.warn(`${key} not set in window.`);
        }

        return window[key] || 0;
    },
    addAdformPlaceholder: addAdformPlaceholder,
    removeAdformPlaceholder: removeAdformPlaceholder,
    adjustSlideTrackingIndexes: adjustSlideTrackingIndexes,
    initAdformRequestLifecycle: initAdformRequestLifecycle
};
